import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
// import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
// import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_ResponsivePIXIApp } from "../SlotGameType1_ResponsivePIXIApp";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
// namespace SlotGames {

    export class MayanHeroes_ResponsivePIXIApp extends SlotGameType1_ResponsivePIXIApp {

        
        protected override helpFactory: IHelpFactory = new MayanHeroesHelpFactory();
        //LED COLOR
		protected override ColorLed: string = "0,139,139\n";
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string = "MayanHeroes") {
            super(multigameParams, initData, gameName);

            this.spinnableReelsParams.topBorderWidth = 8;
            this.spinnableReelsParams.bottomBorderWidth = 8;
        }

        // protected PrepareFonts(resourceManager: ResourceManager): void {

        //     resourceManager.Add(new FontResource(this.basepath + "resources/Monky Stone.ttf", this.resid.ScopedResourceName(["BigSymbolFreeGames-font"])));

        // }
    }
    //Help Colorized
	class MayanHeroesHelpFactory implements IHelpFactory {
		public CreateNewHelp(params: HelpParameters): Help {
			return new MayanHeroesHelp(params);
		}
	}

	class MayanHeroesHelp extends Help {
		protected override BackgroundPanel(): HelpPanelColor {
			let color: HelpPanelColor = {
				backgroundPanelColor: "linear-gradient(rgb(31, 75, 60),rgb(40, 77, 71), rgb(103, 146, 139),rgb(40, 77, 71),rgb(31, 75, 60)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			};

			return color;
		}
	}

// }